export let sortBySortColumnv2 = "vi7fR";
export let sortOrderv2 = "EvgcHe";
export let alphabeticalOrderv2 = "mjoIO";
export let reversedAlphabeticalOrderv2 = "gpj1Yd";
export let oldestOnTopv2 = "Ns0etb";
export let newestOnTopv2 = "E1QZDd";
export let largestOnTopv2 = "GX28re";
export let smallestOnTopv2 = "z3iJLb";
export let highOnTopv2 = "kjKLpe";
export let lowOnTopv2 = "Ysdchc";
export let soonestOnTopv2 = "Bcepie";
export let latestOnTopv2 = "fznsCd";
export let completedOnTop = "f5I0sd";
export let unflaggedOnTop = "HUuKEd";
export let unflaggedDueDateOnTop = "l$DuZd";
export let todayDueDateOnTop = "L4Wwj";
export let messagesOnTop = "Sn6w2";
export let meetingRequestsOnTop = "N4pL9b";
export let dateSortColumnv2 = "ibb29d";
export let mostRecentSearchSortOrder = "WNnrae";
export let mostRelevantSearchSortOrder = "MdT21d";
export let fromSortColumnv2 = "EAOAmc";
export let sizeSortColumnv2 = "VZFxOb";
export let importanceSortColumnv2 = "Cm3j$b";
export let categorySortColumnv2 = "ybGTWb";
export let toSortColumnv2 = "Nw9Vne";
export let returnTimeSortColumnv2 = "dFI8";
export let subjectSortColumn = "Ul3twd";
export let prioritySortColumn = "ENKZZ";
export let flagStatusSortColumn = "i$5Npe";
export let flagDueDateSortColumn = "UkMrxb";
export let itemClassSortColumn = "buZPw";
export let sortColumnMenuButtonLabel = "$3mli";
export let sortColumnMenuTooltip = "oZSndb";
export let newLabel = "uaFPde";
export default {sortBySortColumnv2,sortOrderv2,alphabeticalOrderv2,reversedAlphabeticalOrderv2,oldestOnTopv2,newestOnTopv2,largestOnTopv2,smallestOnTopv2,highOnTopv2,lowOnTopv2,soonestOnTopv2,latestOnTopv2,completedOnTop,unflaggedOnTop,unflaggedDueDateOnTop,todayDueDateOnTop,messagesOnTop,meetingRequestsOnTop,dateSortColumnv2,mostRecentSearchSortOrder,mostRelevantSearchSortOrder,fromSortColumnv2,sizeSortColumnv2,importanceSortColumnv2,categorySortColumnv2,toSortColumnv2,returnTimeSortColumnv2,subjectSortColumn,prioritySortColumn,flagStatusSortColumn,flagDueDateSortColumn,itemClassSortColumn,sortColumnMenuButtonLabel,sortColumnMenuTooltip,newLabel};